
export class AuthenticationException extends Error {
    public detail: any;
    constructor(message: string = "Authentication Failure", detail?: any) {
        super(message);
        this.name = "AuthenticationException";
        this.detail = detail;
    }
}


/**
 * 访问，要求进行完整验证
 */
export class InsufficientAuthenticationException extends AuthenticationException {
    public detail: any;
    constructor(message: string = "InsufficientAuthentication", detail?: any) {
        super(message);
        this.name = "InsufficientAuthenticationException";
        this.detail = detail;
    }
}


export class AccessDeniedException extends Error {
    public detail: any;
    constructor(message: string = "AccessDenied", detail?: any) {
        super(message);
        this.name = "AccessDeniedException";
        this.detail = detail;
    }
}

export function isAuthenticationException(error: any): error is AuthenticationException {
    return (error instanceof Error && error.name === 'AuthenticationException')
}
export function isInsufficientAuthenticationException(error: any): error is InsufficientAuthenticationException { {
    return (error instanceof Error && error.name === 'InsufficientAuthenticationException')
}}

export function isAccessDeniedException(error: any): error is AccessDeniedException {
    return error instanceof Error && error.name === 'AccessDeniedException';
}